(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animationsEnabled = document.body.hasAttribute('data-animations-enabled') && !prefersReducedMotion;

  /* ---------------------------------------------------
     Header: solid background after scrolling past hero
  --------------------------------------------------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var threshold = 60;

    function update() {
      if (window.scrollY > threshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------------------------------------------------
     Scroll reveal for sections marked [data-scroll-reveal]
  --------------------------------------------------- */
  function initScrollReveal() {
    var targets = document.querySelectorAll('[data-scroll-reveal]');
    if (!targets.length) return;

    if (!animationsEnabled || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------
     Subtle parallax drift on the hero background media
  --------------------------------------------------- */
  function initHeroParallax() {
    if (!animationsEnabled) return;
    var hero = document.querySelector('[data-hero]');
    var media = hero ? hero.querySelector('.hero__media-el') : null;
    if (!hero || !media || media.tagName === 'IFRAME') return;

    var ticking = false;
    var maxShift = 24;

    function update() {
      var rect = hero.getBoundingClientRect();
      var progress = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
      media.style.transform = 'scale(1.06) translateY(' + (progress * maxShift) + 'px)';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---------------------------------------------------
     Product page: swap main image on thumbnail click.
     Uses delegated events on document so this keeps
     working even if the section markup is re-rendered
     (e.g. by the theme editor's live preview).
  --------------------------------------------------- */
  function initProductGallery() {
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-thumb]');
      if (!thumb) return;

      var gallery = thumb.closest('[data-product-gallery]');
      if (!gallery) return;

      var mainImage = gallery.querySelector('[data-main-image-el]');
      if (!mainImage) return;

      var fullSrc = thumb.getAttribute('data-full');
      var fullSrcset = thumb.getAttribute('data-full-srcset');
      var alt = thumb.getAttribute('data-alt');

      if (fullSrcset) mainImage.setAttribute('srcset', fullSrcset);
      if (fullSrc) mainImage.setAttribute('src', fullSrc);
      if (alt) mainImage.setAttribute('alt', alt);

      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  }

  /* ---------------------------------------------------
     Product form: keep hidden variant id in sync
     with a simple option selector (single-variant safe)
  --------------------------------------------------- */
  function initVariantSync() {
    var form = document.querySelector('.product__form');
    if (!form) return;

    var selects = form.querySelectorAll('[data-option-selector]');
    var hiddenId = form.querySelector('[data-variant-id]');
    if (!selects.length || !hiddenId) return;

    // Basic UX affordance only; full variant JSON matching is left to
    // merchants who enable additional variant apps/blocks as needed.
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        form.dispatchEvent(new CustomEvent('camovex:option-change'));
      });
    });
  }

  /* ---------------------------------------------------
     Mobile menu toggle
  --------------------------------------------------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.classList.toggle('is-active', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------------------------------------------------
     Respect reduced motion for the hero video
  --------------------------------------------------- */
  function initHeroVideoMotion() {
    var video = document.querySelector('.hero__media video');
    if (!video) return;

    if (prefersReducedMotion) {
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
      video.pause();
    }
  }

  /* ---------------------------------------------------
     Init
  --------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initHeaderScroll();
    initMobileMenu();
    initScrollReveal();
    initHeroParallax();
    initHeroVideoMotion();
    initProductGallery();
    initVariantSync();
  });
})();
